import React from "react";
import {
  AppBar,
  Toolbar,
  Button,
  IconButton,
  Typography,
  Tooltip,
 } from "@mui/material";
import { checkForRoles } from "../utils/GetAuth";
import {
  Theme,
  useTheme,
} from "@mui/material/styles";
import { createStyles, makeStyles } from '@mui/styles';

import { useHistory } from "react-router-dom";
import {
  Settings,
  Tune,
  NotificationsNoneTwoTone,
 } from "@mui/icons-material";
import TitlebarMenu from "./SalesOrgDropdown";
import { useLocalStorage } from "../utils/LocalStorageHook";
import NavigationDropdown from "./NavigationDropdown";
import { IS_TEST_SERVER } from "../App";


export const drawerWidth = 240;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      maxHeight: "100%"
    },
    titleBar: {
      flexGrow: 1,
    },
    appBar: {
      zIndex: theme.zIndex.appBar, 
    },
    toolBar: {
      background: (!IS_TEST_SERVER)?theme.palette.primary.main:theme.palette.QA.main,
    },
    // necessary for content to be below app bar
    toolbar: {
      ...theme.mixins.toolbar,
    },
    content: {
      flexGrow: 1,
      [theme.breakpoints.up("md")]: {
        padding: theme.spacing(1),
      },
      [theme.breakpoints.down("md")]: {
        padding: theme.spacing(1),
      },
      margin: 0,
    },
  })
);

interface Props {
  title: string;
  children: React.ReactNode;
  drawer?: React.ReactNode;
}

function TestServerText(props: {dbSystemInd:string}){
  let dbSystemInd = props.dbSystemInd;    
  if(dbSystemInd === 'M'){
    return (<div>Mnt Server (MNR)</div>)
  } else if(dbSystemInd === 'D') {
    return (<div>Dev Server (DNR)</div>)
  }else if(dbSystemInd === 'T') {
    return (<div>DryRun Server (TNR)</div>)
  }else if(dbSystemInd === 'Q') {
    return (<div>QA Server (QNR)</div>)
  } else if(dbSystemInd === 'L') {
    return (<div>Perf Server (LNR)</div>)
  } else if(dbSystemInd === 'P') {
    return (<div>Prod Server (PNR)</div>)
  }else if(dbSystemInd === 'QN1') {
    return (<div>QN1 Server (QN1)</div>)
  }   
  return (<div>Test Server ({dbSystemInd})</div>)
}

export default function ResponsiveDrawer(props: Props) {
  const classes = useStyles();
  const theme = useTheme();
  const history = useHistory();
  const [salesOrg,] = useLocalStorage("SETTINGS.salesOrg", "");
  const [clientId,] = useLocalStorage("SETTINGS.clientId", "100");
  const [dbSystemInd,] = useLocalStorage("SETTINGS.dbSystemInd", "?");

  const handleHistorySettings = () => {
    history.push("/settings");
  };

  return (
    <div className={classes.root}>
      <AppBar position="fixed" className={classes.appBar} key='ResponsiveDrawer' enableColorOnDark={true} >
        <Toolbar className={classes.toolBar}>
          <NavigationDropdown />
          <Typography
            variant="h6"
            className={classes.titleBar}
            noWrap
          >
            {props.title}
          </Typography>
          {(IS_TEST_SERVER)?(
            <Button 
              color="inherit" 
              variant="text" 
              style={{
                backgroundColor: dbSystemInd==='P'?theme.palette.primary.main:theme.palette.action.focus,
              }} 
              startIcon={<NotificationsNoneTwoTone/>}
              ><TestServerText dbSystemInd={dbSystemInd}/>
            </Button>):(<div/>)}
          <TitlebarMenu />
          {(checkForRoles(clientId, salesOrg, ["security_admin","batch_monitor","vp_admin","vs_admin","vp_admin_bulk","vs_admin_bulk"]))?(
            <Button
              color="inherit"
              variant="text"
              onClick={() => history.push("/admin")}
            >
              <Tune /> Admin
            </Button>
            ):(<div></div>)
          }
          <IconButton
              color="inherit"
              onClick={handleHistorySettings}
            >
              <Settings />
            </IconButton>
        </Toolbar>
      </AppBar>
      <div className={classes.content}>
        <div className={classes.toolbar} />
        {props.children}
      </div>
    </div>
  );
}
